export const setRoomsize = (node, value) => {
  node.roomSize.value = value;
}

export const setDampening = (node, value) => {
  node.dampening.value = value;
}